import { render, staticRenderFns } from "./ViewActives.vue?vue&type=template&id=11a4760e&scoped=true"
import script from "./ViewActives.vue?vue&type=script&lang=js"
export * from "./ViewActives.vue?vue&type=script&lang=js"
import style0 from "./ViewActives.vue?vue&type=style&index=0&id=11a4760e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a4760e",
  null
  
)

export default component.exports